<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div class="item van-hairline--bottom" @click="changeLang('zh')">
        <div class="flex_center"><div class="info">中文</div></div>
        <div v-if="lang == 'zh'">✓</div>
      </div>
      <div class="item van-hairline--bottom" @click="changeLang('en')">
        <div class="flex_center"><div class="info">English</div></div>
        <div v-if="lang == 'en'">✓</div>
      </div>
      <div class="item van-hairline--bottom" @click="changeLang('ja')">
        <div class="flex_center"><div class="info">日本語</div></div>
        <div v-if="lang == 'ja'">✓</div>
      </div>
      <div class="item van-hairline--bottom" @click="changeLang('kr')">
        <div class="flex_center"><div class="info">한국어</div></div>
        <div v-if="lang == 'kr'">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Language",
  data() {
    return {
      lang: localStorage.getItem("lang") || "en"
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    changeLang(lang) {
      Toast.loading({ message: '...', duration: 0, forbidClick: true });
      
      // 1. 发送给后端记录
      this.$http({
        method: "get",
        url: "replaceLang",
        data: { lang: lang },
      }).finally(() => {
        // 2. 无论后端接口成功与否，前端必须更新
        localStorage.setItem("lang", lang);
        
        // 3. 终极杀招：重载页面
        // 这一步确保 main.js 重新执行，重新读取 localStorage 中的 lang，并加载对应的 JSON 文件
        window.location.href = window.location.origin + window.location.pathname + '#/';
        setTimeout(() => {
          window.location.reload();
        }, 100);
      });
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .items { background-color: #fff; font-size: 30px; color: #000; padding: 25px; }
.container .items .item { padding: 20px 0; display: flex; justify-content: space-between; align-items: center; }
.flex_center { display: flex; align-items: center; }
</style>
